import Vue from 'vue'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import localeData from 'dayjs/plugin/localeData'

import updateLocale from 'dayjs/plugin/updateLocale'
import localeSl from 'dayjs/locale/sl'
dayjs.extend(updateLocale)
dayjs.extend(utc)
dayjs.extend(localeData)
dayjs.locale(localeSl)

Vue.prototype.$dayjs = dayjs

export default dayjs
